import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import Select from 'react-select';

import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';
import { getBranchOptions } from '../../../../app/store/actions/customerBranch';
import { getDepositsOptionsList } from '../../../../app/store/actions/deposits';
import { getUserPermissions } from '../../../../app/store/actions/users';
import { getMaterialsFamilyOptions } from '../../../../app/store/actions/materialsFamily';
import { getStorageAddressSizesList } from '../../../../app/store/actions/storageAdressSizes';
import { getStorageAddressTypesOptions } from '../../../../app/store/actions/storageAdressTypes';
import { returnFiltersByRules } from '../../../reports/utils';
import ProductHelpers from '../../../../helpers/products';

class FilteringModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      codeFrom: '',
      codeTo: '',
      sectorFrom: '',
      sectorTo: '',
      streetFrom: '',
      streetTo: '',
      levelFrom: '',
      levelTo: '',
      columnFrom: '',
      columnTo: '',
      drawerFrom: '',
      drawerTo: '',
      productFrom: '',
      productTo: '',
      branch: '',
      branchName: '',
      listBranch: [],
      listDeposit: [],
      selectedDeposits: [],
      selectedMaterialsFamily: [],
      materialsFamily: [],
      selectedStorageAddressSizes: [],
      storageAddressSizes: [],
      selectedStorageAddressTypes: [],
      storageAddressTypes: [],
      selectedStockControlTypes: [],
      stockControlTypeOptions: ProductHelpers.stockControlType(),
      controlExpirationDate: 'all',
      columnSide: 'both',
      columnSideLabel: '',
      columnSideList: [],
    };
  }

  componentDidMount() {
    const columnSideList = [
      { label: I18n.t('BEE203' /* Ambos */), value: 'both' },
      { label: I18n.t('BEE3398' /* Par */), value: 'even' },
      { label: I18n.t('BEE3399' /* Ímpar */), value: 'odd' },
    ];

    this.setState({
      columnSideList,
      columnSide: 'both',
      columnSideLabel: I18n.t('BEE203' /* Ambos */),
    });

    this.getMaterialsFamilyOptions();
    this.getStorageAddressSizesList();
    this.getStorageAddressTypesOptions();
  }

  componentDidUpdate(prevProps) {
    if (this.props.showFilterModal && this.props.showFilterModal !== prevProps.showFilterModal) {
      this.branchOptions();
      this.depositsOptionsList();
    }
  }

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  setValueDrop = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });

    if (attr === 'columnSide') {
      const { columnSide } = this.state;
      let columnSideLabel = '';

      if (columnSide === 'both') {
        columnSideLabel = I18n.t('BEE203' /* Ambos */);
      } else if (columnSide === 'even') {
        columnSideLabel = I18n.t('BEE3398' /* Par */);
      } else if (columnSide === 'odd') {
        columnSideLabel = I18n.t('BEE3399' /* Ímpar */);
      }

      await this.setState({
        columnSide,
        columnSideLabel,
      });
    }
  };

  getMaterialsFamilyOptions = async () => {
    const materialsFamily = await this.props.getMaterialsFamilyOptions();
    this.setState({ materialsFamily });
  };

  getStorageAddressTypesOptions = async () => {
    const storageAddressTypes = await this.props.getStorageAddressTypesOptions();
    this.setState({ storageAddressTypes });
  };

  getStorageAddressSizesList = async () => {
    await this.props.getStorageAddressSizesList();
    const storageAddressSizes = [];
    const addressSizesList = this.props.addressSizesList || [];

    addressSizesList.forEach((element) => {
      storageAddressSizes.push({ value: element.id, label: `${element.code} - ${element.name}` });
    });

    this.setState({ storageAddressSizes });
  };

  branchOptions = async () => {
    try {
      const listBranch = await this.props.getBranchOptions();
      const userPermission = await this.props.getUserPermissions();

      if (!this.state.branch && userPermission && userPermission.mainBranch) {
        const mainBranch = listBranch.find((branch) => branch.value === userPermission.mainBranch);

        if (mainBranch) {
          this.setState({
            branch: mainBranch.value,
            branchName: mainBranch.label,
          });
        }
      }

      this.setState({ listBranch: [...listBranch || []] });
    } catch (err) {
      addNotification(
        'danger',
        I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
        I18n.t('BEE1969' /* Erro ao buscar dados */),
        'top-right',
      );
    }
  };

  depositsOptionsList = async () => {
    try {
      const listDeposit = await this.props.getDepositsOptionsList();
      this.setState({ listDeposit: [...listDeposit || []] });
    } catch (err) {
      addNotification(
        'danger',
        I18n.t('BEE4823' /* Etiqueta Embalagem Fracionada por Saldo */),
        I18n.t('BEE1969' /* Erro ao buscar dados */),
        'top-right',
      );
    }
  };

  handleMultiSelected = async (event, attr) => {
    const selected = [];
    event.map((element) => (
      selected.push({ value: element.value, label: element.label })
    ));

    await this.setState({
      [`${attr}`]: selected,
    });
  };

  applyFilters = () => {
    const {
      codeFrom, codeTo, sectorFrom, sectorTo, streetFrom, streetTo, levelFrom, levelTo,
      columnFrom, columnTo, drawerFrom, drawerTo, productFrom, productTo, branch,
      selectedDeposits, selectedMaterialsFamily, selectedStorageAddressSizes,
      selectedStorageAddressTypes, selectedStockControlTypes, controlExpirationDate, columnSide,
    } = this.state;

    if (!branch) {
      addNotification(
        'danger',
        I18n.t('BEE2386' /* Verifique os Filtros */),
        I18n.t('BEE1781' /* Informe a filial */),
        'top-right',
      );
      return;
    }

    const filters = returnFiltersByRules([
      ['addressCode', { type: 'between', value: [codeFrom.toLocaleUpperCase(), codeTo.toLocaleUpperCase()] }],
      ['productCode', { type: 'between', value: [productFrom, productTo] }],
      ['sector', { type: 'between', value: [sectorFrom.toLocaleUpperCase(), sectorTo.toLocaleUpperCase()] }],
      ['street', { type: 'between', value: [streetFrom.toLocaleUpperCase(), streetTo.toLocaleUpperCase()] }],
      ['column', { type: 'between', value: [columnFrom.toLocaleUpperCase(), columnTo.toLocaleUpperCase()] }],
      ['level', { type: 'between', value: [levelFrom.toLocaleUpperCase(), levelTo.toLocaleUpperCase()] }],
      ['drawer', { type: 'between', value: [drawerFrom.toLocaleUpperCase(), drawerTo.toLocaleUpperCase()] }],
      ['branchCode', { type: 'and', value: branch }],
      ['depositCode', { type: 'in', value: selectedDeposits }],
      ['materialsFamily', { type: 'in', value: selectedMaterialsFamily }],
      ['storageAddressSizes', { type: 'in', value: selectedStorageAddressSizes }],
      ['storageAddressTypes', { type: 'in', value: selectedStorageAddressTypes }],
      ['stockControlType', { type: 'in', value: selectedStockControlTypes }],
      ['controlExpirationDate', { type: 'and', value: controlExpirationDate }],
      ['columnSide', columnSide],
    ]);

    this.props.onApplyFilters(filters, columnSide);
  };

  renderControlExpirationDate = () => {
    const { controlExpirationDate } = this.state;
    const options = [
      { label: I18n.t('BEE203' /* Ambos */), value: 'all' },
      { label: I18n.t('BEE172' /* Sim */), value: 'yes' },
      { label: I18n.t('BEE173' /* Não */), value: 'no' },
    ];

    return (
      <div className="form-group row m-b-15 mt-2" style={{ height: 'auto' }}>
        <span className="col-form-label col-md-3 d-flex align-items-center">
          {`${I18n.t('BEE4827' /* Controla Vencimento */)}:`}
        </span>
        <div className="col-md-8 d-flex align-items-center">
          {options.map((option) => (
            <div key={option.value} className="radio radio-css radio-inline">
              <input
                type="radio"
                id={`controlExpirationDate${option.value}`}
                value={option.value}
                checked={controlExpirationDate === option.value}
                onChange={() => this.setValue('controlExpirationDate', option.value)}
              />
              <label htmlFor={`controlExpirationDate${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderMultiSelect = (label, attr, options, placeholder) => (
    <div className="form-group row m-b-15" style={{ height: 'auto' }}>
      <span className="col-form-label col-md-3">{`${label}:`}</span>
      <div className="col-md-8">
        <Select
          value={this.state[attr]}
          isMulti
          onChange={(event) => this.handleMultiSelected(event || [], attr)}
          closeMenuOnSelect={false}
          blurInputOnSelect={false}
          isSearchable
          styles={{
            control: (defaultStyles) => ({
              ...defaultStyles,
              minHeight: '38px',
              border: '1px solid #ccc',
              boxShadow: 'none',
              color: '#ccc',
              backgroundColor: '#fff',
              borderRadius: '5px',
              fontFamily: 'Open Sans", sans-serif',
              fontWeight: '400',
            }),
            placeholder: (defaultStyles) => ({
              ...defaultStyles,
              color: '#333',
              fontSize: '12px',
            }),
            dropdownIndicator: (defaultStyles) => ({
              ...defaultStyles,
              paddingTop: 0,
              paddingBottom: 0,
              color: '#ccc',
            }),
            clearIndicator: (defaultStyles) => ({
              ...defaultStyles,
              paddingTop: 0,
              paddingBottom: 0,
            }),
          }}
          maxMenuHeight={300}
          placeholder={placeholder}
          options={options}
        />
      </div>
    </div>
  );

  render() {
    const {
      codeFrom, codeTo, sectorFrom, sectorTo, streetFrom, streetTo, levelFrom, levelTo,
      columnFrom, columnTo, drawerFrom, drawerTo, productFrom, productTo,
      branch, branchName, listBranch, columnSide, columnSideLabel, columnSideList,
      materialsFamily, storageAddressSizes,
      storageAddressTypes, listDeposit,
      stockControlTypeOptions,
    } = this.state;
    const { showFilterModal = false } = this.props;

    return (
      <Modal size="xl" isOpen={showFilterModal} toggle={this.props.closeFilters} className="adjustmentPadding">
        <ModalHeader toggle={this.props.closeFilters}>{I18n.t('BEE546' /* Filtros */).toUpperCase()}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col" style={{ borderRight: 'solid 1px #d5dbe0' }}>
              <div className="pt-4 add_display_flex">
                <Form
                  noPanel
                  leftType
                  setValue={this.setValue}
                  setValueDrop={this.setValueDrop}
                  inputs={(formContext) => ([
                    formContext.createSelectDropDown(
                      { value: branch, label: branchName },
                      'branch',
                      `${I18n.t('BEE145' /* Filial */)}:`,
                      listBranch,
                      false,
                      undefined,
                      ['col-md-3', 'col-md-8'],
                      undefined,
                      undefined,
                      undefined,
                      true,
                    ),
                    formContext.customComponent(
                      this.renderMultiSelect(
                        I18n.t('BEE182' /* Depósito */),
                        'selectedDeposits',
                        listDeposit,
                        I18n.t('BEE3753' /* Todos os depósitos foram selecionados */),
                      ),
                    ),
                    formContext.createInputRange(
                      { from: productFrom, to: productTo },
                      { from: 'productFrom', to: 'productTo' },
                      `${I18n.t('BEE225' /* Produto */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                      undefined,
                      undefined,
                      undefined,
                      undefined,
                      false,
                      false,
                      ['form-group row m-b-15', 'col-form-label col-md-3'],
                    ),
                    formContext.customComponent(this.renderControlExpirationDate()),
                    formContext.customComponent(
                      this.renderMultiSelect(
                        I18n.t('BEE707' /* Tipo de Controle do Produto */),
                        'selectedStockControlTypes',
                        stockControlTypeOptions,
                        I18n.t('BEE4826' /* Todos os tipos de controle foram selecionados */),
                      ),
                    ),
                    formContext.customComponent(
                      this.renderMultiSelect(
                        I18n.t('BEE1080' /* Família de Materiais */),
                        'selectedMaterialsFamily',
                        materialsFamily,
                        I18n.t('BEE3518' /* Todas as famílias foram selecionadas */),
                      ),
                    ),
                    formContext.customComponent(
                      this.renderMultiSelect(
                        I18n.t('BEE3522' /* Classificações de Endereço */),
                        'selectedStorageAddressSizes',
                        storageAddressSizes,
                        I18n.t('BEE3519' /* Todas as classificações foram selecionadas. */),
                      ),
                    ),
                    formContext.customComponent(
                      this.renderMultiSelect(
                        I18n.t('BEE732' /* Tipos de Endereço */),
                        'selectedStorageAddressTypes',
                        storageAddressTypes,
                        I18n.t('BEE3520' /* Todos os tipos de endereços estão selecionados. */),
                      ),
                    ),
                  ])}
                />
              </div>
            </div>
            <div className="col" style={{ borderLeft: 'solid 1px #d5dbe0' }}>
              <div className="pt-4">
                <Form
                  noPanel
                  leftType
                  setValue={this.setValue}
                  setValueDrop={this.setValueDrop}
                  inputs={(formContext) => ([
                    formContext.createInputRange(
                      { from: codeFrom.toLocaleUpperCase(), to: codeTo.toLocaleUpperCase() },
                      { from: 'codeFrom', to: 'codeTo' },
                      `${I18n.t('BEE267' /* Endereço */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                    formContext.createInputRange(
                      { from: sectorFrom.toLocaleUpperCase(), to: sectorTo.toLocaleUpperCase() },
                      { from: 'sectorFrom', to: 'sectorTo' },
                      `${I18n.t('BEE1854' /* Setor */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                    formContext.createInputRange(
                      { from: streetFrom.toLocaleUpperCase(), to: streetTo.toLocaleUpperCase() },
                      { from: 'streetFrom', to: 'streetTo' },
                      `${I18n.t('BEE121' /* Rua */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                    formContext.createInputRange(
                      { from: columnFrom.toLocaleUpperCase(), to: columnTo.toLocaleUpperCase() },
                      { from: 'columnFrom', to: 'columnTo' },
                      `${I18n.t('BEE281' /* Coluna */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                    formContext.createSelectDropDown(
                      { value: columnSide, label: columnSideLabel },
                      'columnSide',
                      `${I18n.t('BEE3397' /* Gerar Lados (Coluna) */)}:`,
                      columnSideList,
                      false,
                    ),
                    formContext.createInputRange(
                      { from: levelFrom.toLocaleUpperCase(), to: levelTo.toLocaleUpperCase() },
                      { from: 'levelFrom', to: 'levelTo' },
                      `${I18n.t('BEE283' /* Nível */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                    formContext.createInputRange(
                      { from: drawerFrom.toLocaleUpperCase(), to: drawerTo.toLocaleUpperCase() },
                      { from: 'drawerFrom', to: 'drawerTo' },
                      `${I18n.t('BEE285' /* Gaveta */)}:`,
                      { from: 'z'.repeat(20), to: 'z'.repeat(20) },
                      { from: 'text', to: 'text' },
                    ),
                  ])}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-120 btn-white p-5 m-5"
            onClick={this.props.closeFilters}
          >
            {I18n.t('BEE99' /* Cancelar */)}
          </button>
          <button
            type="button"
            className="btn btn-120 btn-primary p-5 m-5"
            onClick={this.applyFilters}
          >
            {I18n.t('BEE407' /* Buscar */)}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  addressSizesList: state.storageAddressSizes.storageAddressSizesList,
});

const mapDispatchToProps = (dispatch) => ({
  getBranchOptions: () => dispatch(getBranchOptions()),
  getDepositsOptionsList: () => dispatch(getDepositsOptionsList()),
  getUserPermissions: () => dispatch(getUserPermissions()),
  getMaterialsFamilyOptions: () => dispatch(getMaterialsFamilyOptions()),
  getStorageAddressSizesList: () => dispatch(getStorageAddressSizesList()),
  getStorageAddressTypesOptions: () => dispatch(getStorageAddressTypesOptions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilteringModal);
